<template>
  <span class="documentStatusBadge">
    <CompleteIcon v-if="status === 'complete'" />
    <DivergentIcon v-else-if="status === 'divergent'" />
    <IncompleteIcon v-else />
    <span class="documentStatusText">{{ statusText }}</span>
  </span>
</template>

<script>
import CompleteIcon from '@/components/icons/CompleteIcon.vue'
import DivergentIcon from '@/components/icons/DivergentIcon.vue'
import IncompleteIcon from '@/components/icons/IncompleteIcon.vue'
import { isFinishedUpdaterStatus } from '@/utils/sheetRowFunctions'

export default {
  name: 'DocumentStatusBadge',
  components: {
    CompleteIcon,
    DivergentIcon,
    IncompleteIcon,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    status() {
      const rows = this.rows || []
      if (rows.length === 0) return 'incomplete'
      const finishedCount = rows.filter((row) => isFinishedUpdaterStatus(row.updaterStatus)).length
      if (finishedCount === 0) return 'incomplete'
      if (finishedCount === rows.length) return 'complete'
      return 'divergent'
    },
    statusText() {
      switch (this.status) {
        case 'complete':
          return this.$t('receiptMatcher.statusComplete')
        case 'divergent':
          return this.$t('receiptMatcher.statusDivergent')
        default:
          return this.$t('receiptMatcher.statusIncomplete')
      }
    },
  },
}
</script>

<style scoped>
.documentStatusBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}

.documentStatusText {
  font-size: 0.85rem;
}
</style>